import { Action, handleActions } from "redux-actions";
import * as store from "store2";
import Constants from "./constants";
import ILocalSettingsState, { DEFAULT_STATE } from "./state";

export default handleActions<ILocalSettingsState>(
  {
    [Constants.SAVE_LOCAL_SETTINGS_SUCCESS]: (
      state: ILocalSettingsState,
      action: Action<ILocalSettingsState>
    ): ILocalSettingsState => ({
      ...state,
      ...action.payload,
    }),
  },
  {
    ...DEFAULT_STATE,
    ...store.get(Constants.LOCAL_STORAGE_KEY, {}),
  }
);



// WEBPACK FOOTER //
// ./src/redux/modules/localSettings/reducer.ts